app.service('productTabList', function (
	productDetailDynamicSuite,
	productNav,
	productTabSpecification,
	productTabQuestion,
	productTabOpinions,
	productTabDescription,
	productAccessories
) {

	function init() {

		if (productNav.dynamicSuiteAvailable()) {
			productDetailDynamicSuite.init();
		}

		if (productNav.productQuestionAvailable()) {
			productTabQuestion.init();
		}

		if (productNav.specificationAvailable()) {
			productTabSpecification.init();
		}

		if (productNav.opinionAvailable()) {
			productTabOpinions.init();
		}

		if (productNav.accessoriesAvailable()) {
			productAccessories.init();
		}

		productTabDescription.init();
	}

	return {
		init
	};
});